const notificationCloseBG = header.find('.menus-close-bg');
const notificationOverflow = header.find('.notification-overflow');
const notificationList = header.find('.header-notifications-list');
const notificationNavBtns = header.find('.nav-item-link[href$="#notification"]');
const notificationCardsIds = [];
let notificationTL;

const notificationLenis = new Lenis({
  wrapper: notificationList.get(0),
  autoRaf: true,
});

const timeControl = () => {
  const timeElement = $('.notification-time');
  const dateElement = $('.notification-date');
  
  const now = new Date();

  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    hour12: true
  });

  const timeZoneFormatter = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short'
  });

  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    day: 'numeric',
    month: 'long'
  });

  const formattedTime = timeFormatter.format(now);
  const formattedTimeZone = timeZoneFormatter
    .formatToParts(now)
    .find(p => p.type === 'timeZoneName').value;

  const formattedDateParts = dateFormatter.formatToParts(now);

  const weekday = formattedDateParts.find(p => p.type === 'weekday').value.toUpperCase();
  const day = formattedDateParts.find(p => p.type === 'day').value;
  const month = formattedDateParts.find(p => p.type === 'month').value;

  const formattedDate = `${weekday}, ${day} ${month}`;

  timeElement.html(
    `${formattedTime}<span class="time-zone"> ${formattedTimeZone}</span>`
  );
  dateElement.text(formattedDate);
};

const checkNewNotifications = () => {
  const notificationCards = notificationList.find('.notification-card');
  const checkedNotifications = JSON.parse(localStorage.getItem('checkedNotifications') || '[]');

  let newCount = 0;

  notificationCards.each(function () {
    const id = $(this).attr('data-uuid');
    notificationCardsIds.push(id);
    if (!checkedNotifications.includes(id)) {
      newCount += 1;
    }
  });

  setNotificationNavCounter(newCount);
};

const addNotificationNavCounter = () => {
  const notificationButton = header.find('.nav-item-link[href$="#notification"]');

  notificationButton.each(function (index) {
    if (index == 0) {
      const notificationButtonParent = $(this).closest('.nav-item');
      const notificationButtonHover = notificationButtonParent.find('.nav-item-link-text-hover');
      const notificationCounterParent = $('<span>', { class: 'nav-item-notification-counter-parent' });
      const notificationCounterBorder = $('<span>', { class: 'nav-item-notification-counter-border' });
      const notificationCounter = $('<span>', { class: 'nav-item-notification-counter', text: '0' });
      notificationCounterBorder.append(notificationCounter);
      notificationCounterParent.append(notificationCounterBorder);
      $(this).append(notificationCounterParent.clone());
      notificationButtonHover.append(notificationCounterParent);
    }
  });
};

const setNotificationNavCounter = (count) => {
  notificationNavBtns.each(function (index) {
    if (index == 0) {
      const notificationCounterParent = $('.nav-item-notification-counter-parent');
      const notificationCounterBorder = $('.nav-item-notification-counter-border');
      const notificationCounter = $('.nav-item-notification-counter');
      const parentPadding = pxToVw(Number(notificationCounterParent.css('padding-inline').replace('px', '')));
      notificationCounter.text(count);

      const notificationCounterWidth = pxToVw(notificationCounter.outerWidth());
      gsap.set(notificationCounterBorder, { width: `${notificationCounterWidth}vw` });
      const notificationCounterBorderWidth = pxToVw(notificationCounterBorder.outerWidth()) - parentPadding * 2;
      gsap.set(notificationCounterParent, { width: `${notificationCounterBorderWidth}vw` });
    }
  });
};

const notificationAnimation = () => {
  gsap.set(notificationOverflow, {
    clearProps: 'all',
    display: 'block',
    visibility: 'hidden',
  });
  const notificationNav = $('.nav-item-link[href$="#notification"]');
  const notificationOverflowWidth = pxToVw(notificationOverflow.outerWidth());
  const notificationOverflowHeight = pxToVw(notificationOverflow.outerHeight());
  const notificationNavWidth = pxToVw(notificationNav.outerWidth(true));
  const notificationNavOffset = pxToVw(notificationNav.offset().left);
  const notificationOverflowOffset = 100 - notificationOverflowWidth - 1.875;
  gsap.set(notificationOverflow, {
    clearProps: 'all',
    display: 'none',
    visibility: 'visible',
  });
  const notificationTL = gsap.timeline({
    paused: true,
    onStart: () => {
      isNotificationOpened = true;
      gsap.set(notificationCloseBG, { display: 'block' });
      localStorage.setItem('checkedNotifications', JSON.stringify(notificationCardsIds));
    },
    onReverseComplete: () => {
      isNotificationOpened = false;
      gsap.set(notificationCloseBG, { display: 'none' });
      checkNewNotifications();
    },
  });

  notificationTL.add(
    gsap.fromTo(
      notificationOverflow,
      {
        y: isDesktop() ? '-1.25vw' : 0,
        left: isDesktop() ? `${notificationNavOffset}vw` : 0,
        width: isDesktop() ? `${notificationNavWidth}vw` : '100vw',
        height: '0vw',
      },
      {
        y: 0,
        left: isDesktop() ? `${notificationOverflowOffset}vw` : 0,
        width: `${notificationOverflowWidth}vw`,
        height: `${notificationOverflowHeight}vw`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  return notificationTL;
};

const notificationOpenControl = () => {
  const notificationButton = header.find('.nav-item-link[href$="#notification"]');

  notificationButton.on('click', () => {
    if (!isMenuOpened) {
      if (isNotificationOpened) {
        notificationTL.reverse();
      } else if (isCartNotificationOpened && !isNotificationOpened) {
        cartNotificationTL.reverse();
        gsap.delayedCall(1, () => notificationTL.play());
      } else if (isCartOpened && !isNotificationOpened) {
        cartTL.reverse();
        gsap.delayedCall(1, () => notificationTL.play());
      } else {
        notificationTL.play();
      }
      isNotificationOpened = !isNotificationOpened;
    }
  });
};

const initNotification = () => {
  timeControl();
  addNotificationNavCounter();
  checkNewNotifications();

  notificationTL = notificationAnimation();
  $(window).on('deviceChange', function () {
    if (notificationTL) notificationTL.kill();
    notificationTL = notificationAnimation();

    if (isNotificationOpened) {
      notificationTL.play();
    }
  });

  notificationOpenControl();
  notificationCloseBG.on('click', function () {
    notificationTL.reverse();
    isNotificationOpened = false;
  });
}

/*
$(window).on('load', function () {
  initNotification()
});
*/

addSectionObserver(header, initNotification);
